module.exports = __webpack_public_path__ + "img/simulator_logo.0be3be8b.svg";